import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchSignupGenerator } from 'redux/signup-generator/actions';

const previewTermsDecorator = (WrapperPreviewComponent) => {
  class PreviewEmailSignupTermsDecorator extends Component {
    static propTypes = {
      me: PropTypes.object,
      signupGenerator: PropTypes.object,
      fetchSignupGenerator: PropTypes.func,
    };
    static defaultProps = {
      me: null,
      signupGenerator: null,
      fetchSignupGenerator: null,
    };

    render() {
      return (
        <WrapperPreviewComponent
          me={this.props.me}
          signupGenerator={this.props.signupGenerator}
          fetchSignupGenerator={this.props.fetchSignupGenerator}
          {...this.props}
        />
      );
    }

  }
  const mapStateToProps = state => (
    {
      me: state.usersReducer.me,
      signupGenerator: state.emailSignupGenerator.signupGenerator,
    }
  );
  return connect(
    mapStateToProps,
    {
      fetchSignupGenerator,
    },
  )(PreviewEmailSignupTermsDecorator);
};

export default previewTermsDecorator;
